<template>
  <!-- eslint-disable max-len -->
  <div>
    <main
      id="main"
      ref="main"
      :class="{'confirm-order mobile': true,
               'ivs-failed': failedIvsVerification }"
    >
      <!-- <div id="exp-banner">
        <InfoPanel
          v-if="failedIvsVerification && !flagAmpersendEnabled"
          id="in-person-proofing"
          :display-panel="true"
          info-type="danger"
        >
          <p><strong>Your Change-of-Address is NOT complete.</strong></p>
          <p>{{ inPersonProofingMessage }}</p>
        </InfoPanel>
      </div> -->
      <section class="u-container pb-0">
        <h1 class="font-bold text-4xl">
          USPS<br>Change-of-Address<sup>®</sup>
        </h1>
        <ProgressBar
          v-if="!showChoiceExperience"
          :steps="6"
          :current="6"
        />
        <IndividualProgressBarWithSteps
          v-if="showChoiceExperience"
          :mobile="true"
        />
      </section>
      <div id="content">
        <section class="u-container--x mt-2">
          <template v-if="mcoa">
            <p class="mt-4">
              There is one more step to complete: check your email.<br>You'll receive an email confirmation from us soon. In the email, click on the provided link to continue and finalize your Change-of-Address process.
            </p>
          </template>
          <template v-else>
            <!-- <BannerMobileCoaSuccess :show-cfps-id="showCfpsId" /> -->
            <div
              v-show="flagAccessHandoffEnabled"
              id="amp-success-page"
              class="mt-2"
            >
              <div
                id="amp-offers"
                ref="offers"
              >
                <OffersBiz
                  v-if="offersBizSegment"
                  :mover-type="moverType"
                  :show-cfps-id="showCfpsId"
                />
                <OffersIndFamTemp
                  v-else
                  :forward-type="forwardType"
                  :mover-type="moverType"
                  :show-cfps-id="showCfpsId"
                />
              </div>
            </div>
          </template>
          <div
            id="hair-line"
            class="c-hairline mt-6"
          />
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import {
  ProgressBar,
  IndividualProgressBarWithSteps,
} from '@mgo/ui/lib/components';
import Cookies from 'js-cookie';
import { mobileAnalytics } from './analytics';
import confirmOrderMixin from './mixin';
import InfoPanel from '../../components/info-panel.vue';

import OffersBiz from '../../splits/ConfirmOrder/MobileCoaConfirmationSuccess.vue';
import OffersIndFamTemp from '../../splits/ConfirmOrder/MobileCoaConfirmationSuccess.vue';
//import BannerMobileCoaSuccess from '../../splits/ConfirmOrder/BannerMobileCoaSuccess.vue';

export default {
  name: 'ConfirmOrder',
  components: {
    // InfoPanel,
    OffersBiz,
    OffersIndFamTemp,
    // BannerMobileCoaSuccess,
    ProgressBar,
    IndividualProgressBarWithSteps,
  },
  mixins: [confirmOrderMixin],
  computed: {
    showNonControlExperience: () => JSON.parse(sessionStorage.getItem('showNonControlExperience')) ?? false,
    showChoiceExperience: () => JSON.parse(sessionStorage.getItem('showChoiceExperience')),
    analytics() {
      return mobileAnalytics();
    },
    userNeedsReprompt() {
      return !this.autofill
        && !this.repromptShown
        && !this.showReprompt;
    },
  },
  async mounted() {
    if (!this.cfpsId && !this.dcoa) {
      this.$router.push({ name: 'disclaimer' });
      this.$store.commit('DISABLE_LOADER');
      return;
    }
    if (this.flagAmpersendEnabled && this.flagAccessHandoffEnabled) {
      this.$amp.veil(this.$refs.main);
    }
    await this.hydrateCOA();
    if (this.flagAmpersendEnabled && this.flagAccessHandoffEnabled) {
      try {
        await this.getAmpersendExperiences();
      } catch {
        this.amp_data = [];
      } finally {
        this.$amp.unveil(this.$refs.main);
      }
    }
    this.$store.commit('DISABLE_LOADER');

    if (this.cfpsId !== '') {
      this.$coa.reset();
      this.$deleteSession();
      Cookies.remove('coa');
      Cookies.remove('coa_complete');
      localStorage.removeItem('ampersend_data');
    }
  },
};
</script>
